exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loading_loading_background__OoMy3 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(125, 125, 125, 0.5);\n  color: blue;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2; }\n\n.loading_svg__3YjpQ {\n  width: 10%;\n  height: 10%; }\n", ""]);

// Exports
exports.locals = {
	"loading_background": "loading_loading_background__OoMy3",
	"svg": "loading_svg__3YjpQ"
};